import { NgModule } from '@angular/core';
import { LibraryComponent } from './library.component';
import {
  ErrorMessagesMinLenghtPipe,
  ErrorMessagesMaxLenghtPipe,
  ErrorMessagesMinPipe,
  ErrorMessagesMaxPipe,
  ErrorMessagesRequiredPipe,
  ErrorMessagesInvalidPipe,
  ErrorMessagesDuplicatePipe
} from './pipes/error-messages.pipe';

import { SafeHtmlPipe } from "./pipes/safe-html.pipe";
import { SafeUrlPipe } from './pipes/safe-url.pipe';
import { CustomDatePipe } from "./pipes/custom-date.pipe";
import { UtilService } from "./services/util.service";
import { OrderByPipe } from './pipes/order-by.pipe';
import { TermReplacePipe } from './pipes/term-replace.pipe';

@NgModule({
  declarations: [
    LibraryComponent,
    ErrorMessagesMinLenghtPipe,
    ErrorMessagesMaxLenghtPipe,
    ErrorMessagesMinPipe,
    ErrorMessagesMaxPipe,
    ErrorMessagesRequiredPipe,
    ErrorMessagesInvalidPipe,
    ErrorMessagesDuplicatePipe,
    SafeHtmlPipe,
    SafeUrlPipe,
    CustomDatePipe,
    OrderByPipe,
    TermReplacePipe
  ],
  imports: [
  ],
  exports: [
    LibraryComponent,
    ErrorMessagesMinLenghtPipe,
    ErrorMessagesMaxLenghtPipe,
    ErrorMessagesMinPipe,
    ErrorMessagesMaxPipe,
    ErrorMessagesRequiredPipe,
    ErrorMessagesInvalidPipe,
    ErrorMessagesDuplicatePipe,
    SafeHtmlPipe,
    SafeUrlPipe,
    CustomDatePipe,
    OrderByPipe,
    TermReplacePipe
  ],
  providers: [
    UtilService
  ]
})
export class LibraryModule { }
